import React from 'react';
import { doc, deleteDoc } from 'firebase/firestore';

export default function AdmiEconomico({
  anioInforme,
  setAnioInforme,
  mesInforme,
  setMesInforme,
  informesFiltrados,
  subiendoVoucher,
  subirVoucherInforme,
  db,
  coleccionInformes,
  obtenerRegistros,
  progresoInforme,
  // 📂 Nuevas props para documentos permanentes
  documentosPermanentes = [],
  subiendoPermanente = false,
  subirDocumentoPermanente,
  eliminarDocumentoPermanente
}) {
  return (
    <div>
      <h2 style={{ marginTop: 0, color: '#1e293b' }}>Informe Financiero y Mantenimiento</h2>
      
      <div style={{ backgroundColor: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '10px', padding: '20px', marginBottom: '25px', display: 'flex', gap: '20px', flexWrap: 'wrap' }}>
        <div>
          <label style={{ fontWeight: 'bold', fontSize: '0.9rem' }}>Año:</label>
          <select value={anioInforme} onChange={e => setAnioInforme(e.target.value)} style={{ marginLeft: '8px', padding: '6px' }}>
            {['2024','2025','2026','2027','2028','2029','2030'].map(a => <option key={a} value={a}>{a}</option>)}
          </select>
        </div>
        <div>
          <label style={{ fontWeight: 'bold', fontSize: '0.9rem' }}>Mes / Tipo:</label>
          <select value={mesInforme} onChange={e => setMesInforme(e.target.value)} style={{ marginLeft: '8px', padding: '6px' }}>
            {['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Setiembre','Octubre','Noviembre','Diciembre','Unitario'].map(m => (
              <option key={m} value={m}>{m}</option>
            ))}
          </select>
        </div>
      </div>

      <div style={{ backgroundColor: '#f0fdf4', border: '2px dashed #10b981', borderRadius: '10px', padding: '20px', textAlign: 'center', marginBottom: '25px' }}>
        <h4 style={{ color: '#166534', marginTop: 0 }}>Subir Documentos o Comprobantes a {mesInforme} {anioInforme}</h4>
        <p style={{ fontSize: '0.85rem', color: '#15803d', margin: '0 0 15px 0' }}>Puedes seleccionar varios archivos a la vez. Cada uno conservará su nombre original automáticamente.</p>
        
        <div style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap' }}>
          <label style={{ backgroundColor: subiendoVoucher ? '#94a3b8' : '#10b981', color: 'white', padding: '10px 24px', borderRadius: '6px', cursor: subiendoVoucher ? 'not-allowed' : 'pointer', fontWeight: 'bold', fontSize: '0.95rem', display: 'inline-block' }}>
            {subiendoVoucher ? `⏳ Subiendo documentos (${progresoInforme || 0}%)...` : '📎 Seleccionar y Subir Varios Documentos'}
            <input 
              type="file" 
              multiple 
              accept=".pdf, .jpg, .jpeg, .png, .xlsx, .xls" 
              onChange={subirVoucherInforme} 
              style={{ display: 'none' }} 
              disabled={subiendoVoucher} 
            />
          </label>
        </div>

        {subiendoVoucher && (
          <div style={{ maxWidth: '600px', margin: '15px auto 0 auto', textAlign: 'left' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.85rem', fontWeight: 'bold', color: '#166534', marginBottom: '5px' }}>
              <span>Procesando y subiendo documentos...</span>
              <span>{progresoInforme || 0}%</span>
            </div>
            <div style={{ width: '100%', backgroundColor: '#e2e8f0', borderRadius: '10px', height: '10px', overflow: 'hidden' }}>
              <div 
                style={{ 
                  width: `${progresoInforme || 0}%`, 
                  backgroundColor: '#10b981', 
                  height: '100%', 
                  transition: 'width 0.2s ease-in-out' 
                }}
              ></div>
            </div>
          </div>
        )}
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))', gap: '15px', marginBottom: '40px' }}>
        {informesFiltrados.map(inf => (
          <div key={inf.id} style={{ backgroundColor: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '8px', padding: '15px', position: 'relative' }}>
            <button onClick={async () => { await deleteDoc(doc(db, coleccionInformes, inf.id)); await obtenerRegistros(); }} style={{ position: 'absolute', top: '10px', right: '10px', background: 'none', border: 'none', cursor: 'pointer' }} title="Eliminar documento">🗑️</button>
            <h4 style={{ margin: '0 0 8px 0', wordBreak: 'break-word', paddingRight: '20px', fontSize: '0.9rem' }}>📄 {inf.descripcion}</h4>
            <a href={inf.archivoUrl} target="_blank" rel="noopener noreferrer" style={{ color: '#0284c7', fontWeight: 'bold', textDecoration: 'underline', fontSize: '0.85rem' }}>Ver Documento ↗</a>
          </div>
        ))}
      </div>

      {/* 📚 SECCIÓN DE DOCUMENTOS PERMANENTES (REGLAMENTOS, MANUALES, ETC.) */}
      <div style={{ borderTop: '2px solid #cbd5e1', paddingTop: '30px', marginTop: '20px' }}>
        <h3 style={{ color: '#1e293b', marginBottom: '5px' }}>📚 Documentos Permanentes e Institucionales</h3>
        <p style={{ fontSize: '0.85rem', color: '#64748b', marginBottom: '20px' }}>
          Espacio exclusivo para reglamentos internos, manuales de convivencia y normativas generales que no dependen de ningún mes o año.
        </p>

        <div style={{ backgroundColor: '#eff6ff', border: '2px dashed #3b82f6', borderRadius: '10px', padding: '20px', textAlign: 'center', marginBottom: '20px' }}>
          <h4 style={{ color: '#1e40af', marginTop: 0 }}>Subir Documento Permanente</h4>
          <label style={{ backgroundColor: subiendoPermanente ? '#94a3b8' : '#3b82f6', color: 'white', padding: '8px 20px', borderRadius: '6px', cursor: subiendoPermanente ? 'not-allowed' : 'pointer', fontWeight: 'bold', fontSize: '0.9rem', display: 'inline-block' }}>
            {subiendoPermanente ? '⏳ Subiendo documento...' : '📎 Seleccionar Documento Permanente'}
            <input 
              type="file" 
              accept=".pdf, .jpg, .jpeg, .png, .xlsx, .xls" 
              onChange={subirDocumentoPermanente} 
              style={{ display: 'none' }} 
              disabled={subiendoPermanente} 
            />
          </label>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))', gap: '15px' }}>
          {documentosPermanentes.length === 0 ? (
            <div style={{ gridColumn: '1 / -1', textAlign: 'center', padding: '20px', color: '#64748b', fontStyle: 'italic', backgroundColor: '#f8fafc', borderRadius: '8px', border: '1px solid #e2e8f0' }}>
              No hay documentos permanentes registrados en este edificio.
            </div>
          ) : (
            documentosPermanentes.map(docPerm => (
              <div key={docPerm.id} style={{ backgroundColor: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '8px', padding: '15px', position: 'relative' }}>
                <button 
                  onClick={() => eliminarDocumentoPermanente(docPerm.id)} 
                  style={{ position: 'absolute', top: '10px', right: '10px', background: 'none', border: 'none', cursor: 'pointer' }} 
                  title="Eliminar documento permanente"
                >
                  🗑️
                </button>
                <h4 style={{ margin: '0 0 8px 0', wordBreak: 'break-word', paddingRight: '20px', fontSize: '0.9rem' }}>📖 {docPerm.descripcion || docPerm.nombre}</h4>
                <a href={docPerm.archivoUrl} target="_blank" rel="noopener noreferrer" style={{ color: '#0284c7', fontWeight: 'bold', textDecoration: 'underline', fontSize: '0.85rem' }}>Ver Documento ↗</a>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
}